import {css} from 'styled-components'

export const OtherStyles = css`
  #nprogress {
    position: relative;
    z-index: 3000;
  }
`
